import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import { makeStyles } from '@mui/styles'
import { allowedPositions, allowedSizes, allowedFontWeights } from '@/modules/base/components/texts/config'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'

// classes are used through prop
/* eslint-disable mui-unused-classes/unused-classes */
const useStyles = makeStyles(theme => ({
  title: ({ marginBottom }) => {
    return {
      display: 'block',
      lineHeight: '28px',
      marginBottom,
      wordBreak: 'break-word',
    }
  },
  extrasmall: { fontSize: '16px' },
  small20: { fontSize: 20, lineHeight: 28 },
  medium16: { fontSize: 16, lineHeight: 24, fontWeight: theme.fontWeights.medium, letterSpacing: 0.02 },
  small: { fontSize: '21px' },
  medium: { fontSize: '24px' },
  large: { fontSize: '28px' },
  extraLarge: { fontSize: '32px' },
  xxxLarge: { fontSize: '64px', lineHeight: '72px !important' },
  left: { textAlign: 'left' },
  center: { textAlign: 'center' },
  right: { textAlign: 'right' },
  semibold: { fontWeight: theme.fontWeights.semibold },
  mediumbold: { fontWeight: theme.fontWeights.medium },
  bold: { fontWeight: theme.fontWeights.bold },
  icon: {
    display: 'inline-block',
    verticalAlign: 'middle',
    marginTop: 2,
    marginRight: 15,
  },
  svgwrapper: {
    fill: theme.text,
  },
}))

const Title = (props) => {
  const {
    size = 'medium',
    position = 'left',
    children,
    className = '',
    marginBottom = '1rem',
    fontWeight,
    id,
    icon,
  } = props
  const classes = useStyles({ marginBottom })
  const Icon = icon && <div className={classes.icon}><SVGIcon width='24px' height='24px' svg={icon} className={classes.svgwrapper} /></div>

  return (
    !id
      ? <div className={clsx(classes.title, classes[size], classes[position], fontWeight && classes[fontWeight], className)}>{Icon}{children}</div>
      : <div id={id} className={clsx(classes.title, classes[size], classes[position], fontWeight && classes[fontWeight], className)}>{Icon}{children}</div>
  )
}

Title.propTypes = {
  children: PropTypes.node,
  size: PropTypes.oneOf(allowedSizes),
  position: PropTypes.oneOf(allowedPositions),
  className: PropTypes.string,
  marginBottom: PropTypes.string,
  fontWeight: PropTypes.oneOf(allowedFontWeights),
  id: PropTypes.string,
  icon: PropTypes.any,
}

export default Title
